<template>
  <div class="base-dialog">
    <el-dialog
      :custom-class="isFullScreen ? 'el-dialog-trigger-mode el-dialog-full-screen' : 'el-dialog-trigger-mode'"
      :append-to-body="true"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template slot="title">
        <slot name="title">
          <base-dialog-title
            :title="title"
            :show-full-screen="showFullScreen"
            @toggle="handleToggle"
          />
        </slot>
      </template>
      <slot />
      <template slot="footer">
        <slot name="footer">
          <base-dialog-footer
            :footer-button="footerButton"
            @footer="handleBtnClick"
          />
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import BaseDialogTitle from './components/BaseDialogTitle'
import BaseDialogFooter from './components/BaseDialogFooter'
export default {
  name: 'BaseDialog',
  components: {
    BaseDialogTitle,
    BaseDialogFooter
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    showFullScreen: {
      type: Boolean,
      default: true
    },
    footerButton: {
      type: Array,
      default: () => [
        { type: 'default', name: '取消', key: 'cancel' },
        { type: 'primary', name: '确定', key: 'confirm' }
      ]
    }
  },
  data() {
    return {
      isFullScreen: false
    }
  },
  methods: {
    handleToggle(value) {
      this.isFullScreen = value
    },
    handleBtnClick(key) {
      this.$emit('footer', key)
    }
  }
}
</script>

<style lang="scss" scoped></style>
